import React from 'react';
import Plot from "react-plotly.js";
import { Box, Paper, Typography, Divider } from "@mui/material";

const CampaignImpressionScatterplot = ({ data }) => {
  return (
    <Box mt={3}>
      {Object.entries(data).map(([billboardId, billboardData]) => {
        const hourlyData = billboardData.hourly_impression_data || [];

        // Extract arrays for plot
        const times = hourlyData.map((entry) => entry.time);
        const impressions = hourlyData.map((entry) => entry.avg_impressions);

        return (
          <Paper
            key={billboardId}
            elevation={4}
            sx={{ p: 3, mb: 4, borderRadius: 3, backgroundColor: "#f9f9f9" }}
          >
            <Typography
              variant="h6"
              sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}
            >
              Billboard: {billboardId} - {billboardData.location} ({billboardData.height} x {billboardData.width})
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Plot
              data={[
                {
                  x: times,
                  y: impressions,
                  type: "scatter",
                  mode: "markers",
                  name: "Hourly Impressions",
                  marker: {
                    size: 12,
                    color: impressions,
                    colorscale: 'Viridis',
                    showscale: true,
                    colorbar: {
                      title: 'Impressions'
                    }
                  },
                }
              ]}
              layout={{
                title: "Hourly Impression Distribution",
                xaxis: {
                  title: "Time of Day",
                  tickangle: -45,
                  type: "category",
                },
                yaxis: {
                  title: "Average Impressions",
                },
                margin: { t: 40, l: 50, r: 80, b: 60 },
                paper_bgcolor: "#fff",
                plot_bgcolor: "#fff",
                showlegend: false,
                height: 500
              }}
              useResizeHandler
              style={{ width: "100%", height: "100%" }}
              config={{ displayModeBar: true, displaylogo: false }}
            />
          </Paper>
        );
      })}
    </Box>
  );
};

export default CampaignImpressionScatterplot;